var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-template",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-template1",
    serifid: "iconB-template"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,4.857c-0,-1.578 1.279,-2.857 2.857,-2.857l14.286,0c1.576,0 2.857,1.279 2.857,2.857l0,14.286c0,1.576 -1.281,2.857 -2.857,2.857l-14.286,0c-1.578,0 -2.857,-1.281 -2.857,-2.857l-0,-14.286Zm2,2.143l-0,12.143c-0,0.393 0.463,0.857 0.857,0.857l14.286,0c0.393,0 0.857,-0.464 0.857,-0.857l0,-12.143l-16,0Zm14,8l0,2c0,0.552 -0.448,1 -1,1l-10,0c-0.552,0 -1,-0.448 -1,-1l0,-2c0,-0.552 0.448,-1 1,-1l10,0c0.552,0 1,0.448 1,1Zm0,-5l0,2c0,0.552 -0.448,1 -1,1l-10,0c-0.552,0 -1,-0.448 -1,-1l0,-2c0,-0.552 0.448,-1 1,-1l10,0c0.552,0 1,0.448 1,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBTemplate);
export default __webpack_public_path__ + "static/media/iconB-template.94135501c07cf729bfc7793de1125db3.svg";
export { ForwardRef as ReactComponent };